<template>
  <div
    class="flex flex-wrap w-full"
    v-if="session!=null && session.startup_application  && !['9','3','6','8'].includes(session.startup_application.status) || (appType && ecosystemApp && ecosystemApp.application && !['3','5','7','8', '9'].includes(ecosystemApp.application.status))"
  >
    <div v-if="session.startup_application && (session.startup_application.type=='MAIR' || session.startup_application.type=='VAIR')">

    </div>
    <div v-else>
      <div v-if="!session.application_session && !ecosystemSession && !isInvestor" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
        <div class="text-2sm text-blue font-bold mb-2" >{{$t("progBar.cand_recu")}}:</div>
        <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">
          <span>
            -/-
          </span>
        </div>
      </div>
    </div>

    
    <div v-if="!isStartupEcosystem && currentUser && currentUser.role != 'sso' && !isInvestor" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
      <div class="w-1/3 sm:w-1/4 lg:w-1/6 pr-3 lg:pr-5">
        <div v-if="session && session.application_session && session.application_session.first_step_status == 1" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
          <div class="text-2sm text-blue font-bold mb-2">{{$t("progBar.cand_recu")}}:</div>
          <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">
            <span v-if="session.application_session && this.session.startup_application && this.session.startup_application.type && this.session.startup_application.type == 'Label'">
              {{this.session.application_session.count_labeled_applications}}/{{this.session.application_session.max_applications[this.session.startup_application.type]}}
            </span>
            <span v-if="session.application_session && this.session.startup_application && this.session.startup_application.type && this.session.startup_application.type == 'Prélabel'">
              {{this.session.application_session.count_prelabeled_applications}}/{{this.session.application_session.max_applications[this.session.startup_application.type]}}
            </span>
          </div>
        </div>

        <div v-else class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
          <div class="text-2sm text-blue font-bold mb-2">{{$t("progBar.next_session")}}:</div>
          <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">
            <span
              v-if="session.application_session && session.application_session.end_date!=null"
              v-html="formateDate(session.application_session.end_date)"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!isInvestor" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
      <div class="w-1/3 sm:w-1/4 lg:w-1/6 pr-3 lg:pr-5">
        <div v-if="ecosystemSession && ecosystemSession.first_step_status == 1" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
          <div class="text-2sm text-blue font-bold mb-2">{{$t("progBar.cand_recu")}}:</div>
          <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">
            <span v-if="ecosystemSession && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type">
              {{ecosystemSession.total}}/{{ecosystemSession.max_applications[ecosystemApp.application.type] }}
            </span>
          </div>
        </div>

        <div v-else class="w-1/3 sm:w-1/4 lg:w-1/6 pl-1 lg:pl-8">
          <div class="text-2sm text-blue font-bold mb-2">{{$t("progBar.next_session")}}:</div>
          <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">
            <span
              v-if="ecosystemSession && ecosystemSession.end_date!=null"
              v-html="formateDate(ecosystemSession.end_date)"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div :class="isInvestor ? 'w-full sm:w-full lg:w-full ml-20 mr-20' : 'w-1/3 sm:w-2/4 lg:w-4/6'">
      <div class="text-center text-sm md:text-md lg:text-lg text-blue font-bold mb-2 md:mb-4">{{ progress1 }}% {{ $t("progBar.Complete") }}</div>
      <div class="w-full inline-flex md:block rounded-full bg-grey-light md:mb-2">
        <div class="bg-red rounded-full text-xs leading-none py-1 text-center text-white shadow-sm h-3" :style="{ width: progress1 + '%' }"></div>
      </div>
    </div>
    <div v-if="!isInvestor" class="w-1/3 sm:w-1/4 lg:w-1/6 pl-3 lg:pl-5">
      <div class="flex">
        <div class="text-2sm text-blue font-bold mb-2">
          <i class="fas fa-calendar-alt text-grey-light mr-2"></i>
        </div>
        <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold">{{ $t("progBar.deadline") }}</div>
      </div>
      <div v-if="!isStartupEcosystem && currentUser && currentUser.role != 'sso'">
        <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold pl-6">
          <span v-if="session.application_session && session.application_session.first_step_end_date!=null">
            {{new Date(session.application_session.first_step_end_date)| dateFormat('DD/MM/YYYY') }}
          </span>
          <span v-else>--/--/--</span>
        </div>
      </div>
      <div v-else>
        <div class="text-xs lg:text-sm xl:text-2sm text-blue font-bold pl-6">
          <span v-if="ecosystemSession && ecosystemSession.first_step_end_date!=null">
            {{new Date(ecosystemSession.first_step_end_date) | dateFormat('DD/MM/YYYY') }}
          </span>
          <span v-else>--/--/--</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="session.startup_application && session.startup_application.project_name" class="pl-1 lg:pl-8">
      <div class="text-xl text-blue font-bold mb-2">
         <span>
            {{ projectName }}
        </span>
      </div>
   </div>
</template>

<script>
import { APPLICATION_GET_OR_CREATE } from "@/store/actions.type";
import { Fragment } from "vue-fragment";
import { mapGetters } from "vuex";
export default {
  name: "progress-bar",
  components: {
    "fragment": Fragment
  },
  props: {
    progress: Number
  },
  data() {
    return {
      progress1: 0,
      appType : null
    };
  },
  created() {
    this.progress1 = 0;
    if (this.$route.name != "home") {
      if (
        this.session != null &&
        this.session.startup_application != null &&
        this.session.startup_application.progress != undefined &&
        !this.isStartupEcosystem
      ) {
        this.progress1 = Math.round(this.session.startup_application.progress);
      }
    }
  },
  mounted(){
    this.progress1 = 0;
    this.setAppType();
    if(this.$route.path.split("/").includes('checklist')){
      this.appType = true
    }
  if(this.appType && ( this.isStartupEcosystem || this.isInvestor) || this.ecosystemApp.application && ["Certif", "Deal", "Sail"].includes(this.ecosystemApp.application.type)){
      this.progress1 = Math.round(this.ecosystemProgress)
    }
  },
  methods: {
    formateDate(date) {
      return new Date(
        new Date(date).setDate(new Date(date).getDate() + 1)
      ).toLocaleDateString("fr-FR");
    },
    setAppType() {
      this.appType =
        this.ecosystemApp &&
        this.ecosystemApp.application &&
        this.ecosystemApp.application.type
          ? this.ecosystemApp.application.type
          : null;
    }
  },
  watch: {
    startup_application() {
      if (
        this.startup_application != null &&
        this.startup_application.progress != undefined &&
        !this.isInvestor &&
        !this.isStartupEcosystem
      ) {
        this.progress1 = Math.round(this.session.startup_application.progress);
      }
    },
    ecosystemProgress(){
      this.progress1 = 0;
      if(this.appType){
      this.progress1 = Math.round(this.ecosystemProgress)
      }
    },
    ecosystemApp() {
      this.setAppType();
    }
  },
  computed: {
    ...mapGetters(["session", "startup_application","ecosystemProgress", "ecosystemApp", "ecosystemSession", "currentUser"]),
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.app_id || this.$route.params.ecoAppId;
      if (hashId) {
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Air", "Air2", "D4D", "Certif", "deal", "Sail",'MAIR','VAIR'].includes(this.ecosystemApp.application.type) &&
          this.ecosystemApp.application.id == hashId
        ) {
          startupEco = true;
        }
      }

      return startupEco;
    },
    isInvestor() {
      return this.currentUser.role == 'Investor' ? true : false;
    },
    projectName() {
      if (this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true') {
        return this.ecosystemApp.application.project_name;
      }
      return this.session.startup_application.project_name;
    }
  }
};
</script>
